module.exports = "/_next/static/images/inquires-665b005a2ff60a66e8e0443c42d4630f.jpg";